import React from 'react'
import styled from 'styled-components'
import { Column, Row, SpaceBetween } from 'components/common/layout'
import { RangeSliderValueDisplay } from 'components/common/range-slider-value-display'
import { observer } from 'mobx-react'
import { Slider } from 'components/common/slider'
import { PositionFormSubInfoTitleText } from 'components/dashboard/positions/styles'

export const DashboardPositionFormSlider: React.FC<{
  value: number | number[]
  unit: string
  step: number
  min: number
  max: number
  description: string
  onChange: (v: number | number[]) => void
}> = observer(({ step, min, max, value, unit, description, onChange }) => {
  return (
    <Column style={{ gap: 8 }}>
      <SpaceBetween>
        <PositionFormSubInfoTitleText>
          {description}
        </PositionFormSubInfoTitleText>
        <RangeSliderValueDisplay
          min={min}
          max={max}
          value={value}
          unit={unit}
        />
      </SpaceBetween>
      <SliderWrapper>
        <Slider
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={onChange}
        />
      </SliderWrapper>
    </Column>
  )
})

const SliderWrapper = styled(Row)`
  padding: 0 8px;
`
